<template>

  <nav >
    <v-app-bar app color="#224E5F" dark >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      {{ username }}
      <v-spacer></v-spacer>
      <v-btn text @click="cerrarSesion">
        <span class="mr-2">Cerrar Sesión</span>
        <v-icon>fas fa-power-off</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer color="#224E5F" v-model="drawer" 
    dark
    app 
    :temporary="temporary"
    :permanent="permanent"
    :src="getImage"
    >

           <v-list-item two-line>
            <v-list-item-avatar>
              <img src="@/assets/logo.png">
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Infocafe</v-list-item-title>
              <v-list-item-subtitle>Comercialización</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <template>
          
            <v-list shaped>
                <v-list-group
                  v-for="item in items"
                  v-if="item.children"
                  :key="item.title"
                  v-model="item.active"
                  :prepend-icon="item.icon"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.title"></v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item
                    v-for="child in item.children"
                    :key="child.title"
                    link
                    @click="child.action
                            ? openPrinterOptions(child)
                            : $router.push(child.to)"
                    style="cursor: pointer;"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="child.title"></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon v-text="child.icon"></v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-group>
                <!-- ELSE -->
                <!-- ítems sin children, ahora con @click que checa action -->
                <v-list-item
                  v-else
                  :key="item.title"
                  link
                  @click="item.action
                            ? openPrinterOptions(item)
                            : $router.push(item.to)"
                  style="cursor: pointer;"
                >
                  <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list>

          <v-dialog v-model="showPrinterModal" max-width="600px">
  <v-card>
    <v-card-title class="text-h6 font-weight-bold">
      Opciones de Impresión
    </v-card-title>

    <v-card-text>
      <v-container>
        <!-- Sección Constancias -->
        <v-row>
          <v-col cols="12" class="d-flex align-center mb-2">
            <v-icon class="mr-2" color="primary">mdi-file-document-outline</v-icon>
            <span class="text-subtitle-1 font-weight-medium">Constancias</span>
          </v-col>
          <v-col cols="6" v-for="field in constancyFields" :key="field.key">
            <v-text-field
              v-model="printerOptions[field.key]"
              :label="field.label"
              type="number"
            />
          </v-col>
        </v-row>

        <!-- Sección Comprobantes -->
        <v-row class="mt-4">
          <v-col cols="12" class="d-flex align-center mb-2">
            <v-icon class="mr-2" color="primary">mdi-receipt-text-outline</v-icon>
            <span class="text-subtitle-1 font-weight-medium">Comprobantes</span>
          </v-col>
          <v-col cols="6" v-for="field in voucherFields" :key="field.key">
            <v-text-field
              v-model="printerOptions[field.key]"
              :label="field.label"
              type="number"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="grey" @click="showPrinterModal = false">Cancelar</v-btn>
      <v-btn text color="primary" @click="savePrinterOptions">Guardar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


        </template>

    </v-navigation-drawer>
  </nav>
</template>

<script>
import { mapActions, mapState } from "vuex";
import bg from '../assets/fondomenu1.jpg';
export default {
  name: "navbar",
  methods: {
    ...mapActions(["cerrarSesion"]),

    toggleSubMenu(submenuTitle) {
      console.log('submenu', submenuTitle);
      if (this.activeSubMenu === submenuTitle) {
        console.log('abierto');
        // Si el submenú actualmente abierto es igual al que se hizo clic, ciérralo.
        this.activeSubMenu = null;
      } else {
        console.log('cerrar');
        // Si se hizo clic en un submenú diferente, cierra el submenú actualmente abierto y abre el nuevo.
        this.activeSubMenu = submenuTitle;
      }
    },

    // openPrinterOptions(child) {
    //   if (child.action === 'openPrinterOptions') {
    //     const keys = Object.keys(this.printerOptions);
    //     keys.forEach(key => {
    //       const val = localStorage.getItem(key);
    //       this.printerOptions[key] = val !== null ? parseFloat(val) : 0;
    //     });
    //     this.showPrinterModal = true;
    //   } else if (child.to) {
    //     this.$router.push(child.to);
    //   }
      
    // },

    openPrinterOptions(item) {
      console.log("opeming...",item);
      
      // carga la configuración
      Object.keys(this.printerOptions).forEach(key => {
        const val = localStorage.getItem(key);
        this.printerOptions[key] = val !== null ? parseFloat(val) : 0;
      });
      this.showPrinterModal = true;
    },


    savePrinterOptions() {
      const keys = Object.keys(this.printerOptions);
      keys.forEach(key => {
        localStorage.setItem(key, this.printerOptions[key]);
      });
      this.showPrinterModal = false;
      this.$store.dispatch("setSnackbar", {
          text: 'Opciones guardadas correctamente',
      });
    },

  },
  computed: {
    ...mapState(["userType"]),
    isSubMenuActive() {
      return (submenuTitle) => this.activeSubMenu === submenuTitle;
    },
    items() {
        return this.muestreo;
        // return this.type == 1 ? this.muestreo : this.catacion;
    },
    temporary() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
    },
    permanent() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return false
        case 'sm': return false
        case 'md': return true
        case 'lg': return true
        case 'xl': return true
      }
    },
    getImage() {
     return bg;
    }
  },
  data() {
    return {
      username: localStorage.username || '',
      drawer: false,
      showPrinterModal: false,
      printerOptions: {
        constancy_beginY: null,
        constancy_list_beginY: null,
        constancy_spacing: null,
        constancy_footer_beginY: null,
        beginY: null,
        beginX: null,
        line_spacing: null,
      },
      constancyFields: [
        { key: 'constancy_beginY', label: 'Altura inicial Constancia' },
        { key: 'constancy_list_beginY', label: 'Altura de Lista de Comprobantes' },
        { key: 'constancy_spacing', label: 'Espaciado entre líneas' },
        { key: 'constancy_footer_beginY', label: 'Total del Pie' },
      ],
      voucherFields: [
        { key: 'beginY', label: 'Altura inicial Comprobante' },
        { key: 'beginX', label: 'Espaciado en X Comprobante' },
        { key: 'line_spacing', label: 'Espaciado entre líneas' },
      ],
      mini: false,
      group: null,
      type: null,
      activeSubMenu: null,
      muestreo: [
        { title: "Bancos", icon: "fas fa-university", to:{name: 'banks'} },
        
        // { title: "Conductores", icon: "fas fa-truck-moving", to:{name: 'drivers'} },
        { title: "Transferencias", icon: "fas fa-money-check-alt", to:{name: 'reportTransferences'} },
        // { title: "Completar Pagos", icon: "fas fa-money-check-alt", to:{name: 'completePays'} },
        { title: "Café en Depósito", icon: "fas fa-coffee", to:{name: 'deposits'} },
        { title: "Recepción de Café", icon: "fas fa-sign-in-alt", to:{name: 'reception'} },
        { title: "Pago a Productores", icon: "fas fa-shopping-cart", to:{name: 'pays'} },
        { title: "Reporte de Ventas", icon: "fas fa-money-bill-wave-alt", to:{name: 'sales'} },
        { title: "Reporte de Compras", icon: "fas fa-shopping-basket", to:{name: 'purchases'} },
        // { title: "Anticipos", icon: "fas fa-coins", to:{name: 'advances'} },
        { title: "Créditos", icon: "fas fa-coins", to:{name: 'advances'} },
        
        { 
          title: "Retenciones", icon: "fas fa-calculator", active: false,
          children: [
            { title: "Productores", icon: "fas fa-address-card", to:{name: 'providers'} },
            { title: "Cálculo de Retenciones", icon: "fas fa-calculator", to:{name: 'calculate'} },
            { title: "Comprobantes", icon: "fas fa-money-check-alt", to:{name: 'vouchers'} },
            { title: "Retención Mayoristas", icon: "fas fa-address-book", to:{name: 'calculatePartner'} },
            { title: "Reporte Retenciones", icon: "fas fa-file-alt", to:{name: 'reportRetentions'} },
          ],
        },

        { 
          title: "Constancias", icon: "fas fa-folder-plus", active: false,
          children: [
            { title: "Crear Constancia", icon: "fas fa-folder-plus", to:{name: 'constance'} },
            { title: "Constancias", icon: "fas fa-file-alt", to:{name: 'constancy'} },
            { title: "Reporte de Comprobantes", icon: "fas fa-file", to:{name: 'reportVouchers'} },
            // { title: "Constancia", icon: "fas fa-calculator", to:{name: 'constance'} },
          ],
        },

        { 
          title: "Gastos", icon: "fas fa-money-bill-alt", active: false,
          children: [
            { title: "Categorias", icon: "fas fa-stream", to:{name: 'categories'} },
            { title: "Gastos", icon: "fas fa-money-bill-alt", to:{name: 'expenses'} },
            { title: "Reporte de Gastos", icon: "fas fa-search-dollar", to:{name: 'reportExpenses'} },
          ],
        },
        // { 
        //   title: "Reportes", icon: "fas fa-file-alt",
        //   children: [
        //   ],
        
        // },
        // { title: "Compras", icon: "fas fa-calculator", to:{name: 'calculate'} },
        { title: "Reporte SAR", icon: "fas fa-file-excel", to:{name: 'sarExcel'} },
        { title: "Ajustes de impresión", icon: "fas fa-print", action: "openPrinterOptions" },
      ],
      right: true
    };
  },

  watch: {
      group () {
        this.drawer = false
      },
    },
  created() {
    this.type = localStorage.userType;
  }
};
</script>

<style>
 /* v-list-group__header v-list-item v-list-item--active v-list-item--link theme--dark */

/* v-list-item--active v-list-item v-list-item--link theme--dark {
  color: red;
} */
.v-application a {
    color: #ffffff !important;
}

.v-list-group.v-list-group--active.primary--text {
   color: #ffffff !important;
   caret-color: #8D4925 !important;
}

.v-list-group__items {
  padding-left: 16px
}
</style>